import BackgroundEffect from '../components/BackgroundEffect';
const DataProtectionPolicy = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>Data Protection Policy</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. Purpose</h2>
                <p style={styles.paragraph}>
                    The purpose of this Data Protection Policy is to ensure that JSKM Technologies collects, stores, processes, and shares personal and business data in a secure, lawful, and transparent manner.<br />
                    It applies to all clients, users, employees, and third-party partners who interact with the company’s services, including <b>TrustMee,</b> IT solutions, HR, medical, and export/import services.
                </p>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Scope</h2>
                <p style={styles.paragraph}>This policy covers all types of data, including:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Personal Data (e.g., names, contact information, identification details)</li>
                    <li style={styles.listItem}>
                        Business Data (e.g., company details, project information)
                    </li>
                    <li style={styles.listItem}>Technical Data (e.g., IP address, device info, browsing behavior)</li>
                    <li style={styles.listItem}>Transaction Data (e.g., invoices, payments)</li>
                </ul>
                <p style={styles.paragraph}>It applies to all data collected, stored, or processed electronically or physically by JSKM Technologies or its authorized service providers.</p>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. Data Collection</h2>
                <p style={styles.paragraph}>We collect data through:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Direct interactions with clients and users (forms, emails, project discussions)</li>
                    <li style={styles.listItem}>Website and app usage (analytics, cookies, device info)</li>
                    <li style={styles.listItem}>Third-party services (e.g., payment gateways, hosting providers)</li>
                </ul>
                <p style={styles.paragraph}>
                    Only necessary data required for service delivery, legal compliance, and business operations is collected.
                </p>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Legal Basis for Data Processing</h2>
                <p style={styles.paragraph}>
                    We process data based on:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>Consent:</strong> For marketing, newsletters, and specific service opt-ins.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Contractual Necessity:</strong> To deliver services and fulfill agreements.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Legal Obligations:</strong> To comply with applicable laws and regulations.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Legitimate Interests:</strong> For business operations, fraud prevention, and service improvement.
                    </li>
                </ul>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. Data Storage & Security</h2>
                <p style={styles.paragraph}>
                    JSKM Technologies implements robust technical and organizational measures to secure data:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Encryption of sensitive data in storage and transit</li>
                    <li style={styles.listItem}>Secure servers with access control and authentication</li>
                    <li style={styles.listItem}>
                        Regular security audits, monitoring, and backups
                    </li>
                    <li style={styles.listItem}>Restricted access limited to authorized personnel only</li>
                </ul>
                <p style={styles.paragraph}>
                    We ensure all third-party processors comply with equivalent security standards.
                </p>
            </div>

            {/* Section 6 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>6. Data Retention</h2>
                <p style={styles.paragraph}>
                    Data is retained only for as long as necessary to:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Fulfill contractual obligations</li>
                    <li style={styles.listItem}>Comply with legal and regulatory requirements</li>
                    <li style={styles.listItem}>
                        Support operational and business needs
                    </li>
                </ul>
                <p style={styles.paragraph}>
                    After this period, data is securely deleted or anonymized.
                </p>
            </div>

            {/* Section 7 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>7. Data Sharing</h2>
                <p style={styles.paragraph}>
                    Data may be shared only under the following circumstances:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>Internal Use:</strong> Across divisions such as TrustMee, IT services, HR, medical coding, or export/import teams.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Third-Party Service Providers:</strong> Cloud hosting, analytics, payment processors, courier/logistics partners under strict confidentiality agreements.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Legal Compliance:</strong> When required by law, court order, or regulatory authority.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Business Transactions:</strong> In case of mergers, acquisitions, or restructuring, data may be transferred under confidentiality obligations.
                    </li>
                </ul>
                <p style={styles.paragraph}>
                    We do not sell or trade personal data to third parties.
                </p>
            </div>

            {/* Section 8 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>8. User Rights</h2>
                <p style={styles.paragraph}>
                    Users and clients have the following rights regarding their personal data:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Access and receive a copy of personal data</li>
                    <li style={styles.listItem}>Request correction or deletion of inaccurate data</li>
                    <li style={styles.listItem}>Withdraw consent for marketing communications</li>
                    <li style={styles.listItem}>Object to or restrict data processing where applicable</li>
                </ul>
                <p style={styles.paragraph}>
                    Requests should be sent to <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a> Verification may be required before processing.
                </p>
            </div>

            {/* Section 9 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>9. Cookies and Tracking</h2>
                <p style={styles.paragraph}>
                    Data collected through cookies or similar technologies is used for:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Improving website and app functionality</li>
                    <li style={styles.listItem}>Analyzing traffic and usage patterns</li>
                    <li style={styles.listItem}>Personalizing services and content</li>
                </ul>
                <p style={styles.paragraph}>
                    Users can manage cookie preferences via their browser settings. Disabling cookies may affect functionality.
                </p>
            </div>

            {/* Section 10 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>10. Breach Notification</h2>
                <p style={styles.paragraph}>
                    In the unlikely event of a data breach, JSKM Technologies will:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Assess the nature and scope of the breach</li>
                    <li style={styles.listItem}>Notify affected users and regulatory authorities as required by law</li>
                    <li style={styles.listItem}>Implement corrective measures to prevent recurrence</li>
                </ul>
            </div>

            {/* Section 11 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>11. International Data Transfers</h2>
                <p style={styles.paragraph}>
                    Your data may be stored or processed in India or other countries.<br />
                    All transfers are safeguarded with industry-standard protection measures to ensure privacy and compliance.
                </p>
            </div>

            {/* Section 12 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>12. Policy Updates</h2>
                <p style={styles.paragraph}>
                    This policy may be updated to reflect legal, regulatory, or operational changes.<br />
                    Updates will be published on our website with the <b>updated Effective Date.</b> Users are encouraged to review it regularly.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>13. Contact Information</h2>
                <p style={styles.paragraph}>For questions or requests regarding data protection:</p>
                <p style={styles.contact}>
                    <b>JSKM Technologies Private Limited</b> <br />
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                    🌐 <b>Website:</b>{" "}
                    <a
                        href="https://www.jskmtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        https://www.jskmtechnologies.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default DataProtectionPolicy;